<div class="purpose-holder">
  <span class="purpose-text" *ngIf="currentLanguage === 'Hindi'">धन जुटाने का उद्देश्य</span>
  <span class="purpose-text"  *ngIf="currentLanguage === 'English'">Purpose of raising funds</span>
  <span class="purpose-text"  *ngIf="currentLanguage === 'Telugu'">డబ్బుల సేకరణ కారణం</span>
  <span class="purpose-text"  *ngIf="currentLanguage === 'Tamil'">நிதிதிரட்டலுக்கான நோக்கம்</span>

  <mat-form-field>
    <mat-select [(value)]="purpose" (selectionChange)="valueChanged()">
      <mat-option *ngFor="let cause of variablesService.frCausesVernacular" [value]="cause.value">
        {{ cause.label[currentLanguage] }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
